/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyercroplabel2Inputs */

const en_flyercroplabel2 = /** @type {(inputs: Flyercroplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image crop`)
};

const de_flyercroplabel2 = /** @type {(inputs: Flyercroplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildausschnitt`)
};

/**
* | output |
* | --- |
* | "Image crop" |
*
* @param {Flyercroplabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyercroplabel2 = /** @type {((inputs?: Flyercroplabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyercroplabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyercroplabel2(inputs)
	return de_flyercroplabel2(inputs)
});
export { flyercroplabel2 as "flyerCropLabel" }